const checkElementVisibility2 = (element) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0;
};

const initializeCounterConfig = (counter, index) => {
  const countNumber = counter.dataset.count;
  const countPrefix = counter.dataset.prefix || "";
  const countSuffix = counter.dataset.suffix || "";
  const decimalPlaces = parseInt(counter.dataset.decimalPlaces, 10) || 0;

  return {
    id: `counter-${index + 1}`,
    countNumber,
    config: {
      startVal: 0.0,
      decimalPlaces,
      useGrouping: false,
      separator: "",
      prefix: countPrefix,
      suffix: countSuffix,
    },
  };
};

const handleCounterVisibility = (counter, config) => {
  const checkVisibility = () => {
    if (checkElementVisibility2(counter)) {
      new CountUp(counter.id, config.countNumber, config.config).start();
      window.removeEventListener("scroll", checkVisibility);
    }
  };

  checkVisibility();

  if (!checkElementVisibility2(counter)) {
    window.addEventListener("scroll", checkVisibility);
  }
};

const initCounters = () => {
  const counters = document.querySelectorAll("[data-count]");

  counters.forEach((counter, index) => {
    const config = initializeCounterConfig(counter, index);
    counter.id = config.id;

    handleCounterVisibility(counter, config);
  });
};

initCounters();
